import React from 'react'

// Components
import ImageWebp from '../../../../components/ImageWebp/index'

// Hooks
import useDataLayer from '../../../../hooks/useDataLayer/dataLayerBody'

// Assets
import * as S from './style'

const SuperAppFinanceiro = () => {
  const [ sendDatalayerEvent ] = useDataLayer()

  return (
    <S.Section className='pb-5 d-flex align-items-center'>
      <div className='container'>
        <div className='row align-items-center'>
          <div className='col-12 col-md-6 offset-md-1 d-flex justify-content-center order-md-last'>
            <ImageWebp
              arrayNumbers={[ 312, 354, 514, 564 ]}
              pathSrc='https://central-imagens.bancointer.com.br/f04370ea/hero-processo-seletivo-xl.webp'
              altDescription='Homem e mulher sentados e sorrindo em frente à um computador'
            />
          </div>
          <div className='col-12 col-md-5 mt-3'>
            <h1 className='fs-24 fs-md-28 fs-lg-32 fs-xl-48 lh-28 lh-md-30 lh-lg-38 lh-xl-52 font-citrina text-white fw-500'>
              <span className='d-block'>Vem construir</span> o futuro com a gente
            </h1>
            <p className='fs-14 fs-md-16 fs-xl-18 lh-16 lh-md-19 lh-xl-22 text-white mt-3'>
              Saiba mais sobre os benefícios, como funciona o processo seletivo e tudo que você precisa pra dar o próximo passo na sua carreira aqui no Inter.
            </p>
            <S.Btn
              onClick={() => {
                sendDatalayerEvent({
                  section: 'dobra_1',
                  element_action: 'click button',
                  element_name: 'Conferir vagas',
                  section_name: 'Vem construir o futuro com a gente',
                  redirect_url: 'carreiras',
                })
              }}
              to='/carreiras'
              title='Veja nossas vagas disponíveis'
              className='fs-14 text-center rounded-8 px-5 py-2 mt-md-2'
            >
              Conferir vagas
            </S.Btn>
          </div>
        </div>
      </div>
    </S.Section>
  )
}

export default SuperAppFinanceiro
